// src/router.js
import { createRouter, createWebHistory } from "vue-router";
import Layout from "../layouts/BaseLayout.vue";
import Home from "../views/HomeView.vue";
import FooterPages from "../views/FooterPages.vue";
import ContactUs from "../views/ContactUs.vue";
import PropertiesView from "../views/properties/PropertiesView.vue";
import PropertyView from "../views/properties/PropertyView.vue";
import NewProjects from "../views/projects/ProjectsView.vue";
import FindAgent from "../views/brokers/FindBrokerView.vue";
import mortgageView from "../views/MortgageView.vue";
import ProjectView from "../views/projects/ProjectView.vue";
import AgentView from "../views/brokers/AgentView.vue";
import CompanyView from "../views/brokers/CompanyView.vue";
import AgencyHubView from "../views/brokers/AgencyHubView.vue";
import profile from "../views/ProfileView.vue";

const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "",
        component: Home,
        meta: { noPadding: true },
      },
      {
        path: "/:slug",
        name: "FooterPages",
        component: FooterPages,
      },
      {
        path: "/contact-us",
        name: "Contact",
        component: ContactUs,
      },
      {
        path: "/profile",
        name: "profile",
        component: profile,
        meta: { noPadding: false },
      },
      {
        path: "properties/:slug",
        name: "properties",
        component: PropertiesView,
        meta: { noPadding: true },
      },
      {
        path: "/property/:id/:slug",
        name: "PropertyView",
        component: PropertyView,
        meta: { noPadding: false },
      },
      {
        path: "/new-projects",
        name: "NewProjects",
        component: NewProjects,
        meta: { noPadding: true },
      },
      {
        path: "/project/:id/:slug",
        name: "ProjectView",
        component: ProjectView,
        meta: { noPadding: false },
      },
      {
        path: "/find-broker",
        name: "findAgent",
        component: FindAgent,
        meta: { noPadding: true },
      },
      {
        path: "/agent/:id/:slug",
        name: "AgentView",
        component: AgentView,
        meta: { noPadding: true },
      },
      {
        path: "/registration-enquiry",
        name: "AgencyHub",
        component: AgencyHubView,
        meta: { noPadding: true },
      },
      {
        path: "/company/:id/:slug",
        name: "CompanyView",
        component: CompanyView,
        meta: { noPadding: true },
      },
      {
        path: "/mortgage",
        name: "mortgageView",
        component: mortgageView,
        meta: { noPadding: false },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Pass data to the Layout component
router.beforeEach((to, from, next) => {
  Layout.loading = true; // Assuming "loading" is a data property in your Layout component
  next();
});

router.afterEach(() => {
  Layout.loading = false;
});

export default router;
